export default __webpack_public_path__ + "static/media/snow_gold.2a474c25.svg";